export function isDefined<T>(value: T | undefined | null): value is T {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return <T>value !== undefined && <T>value !== null;
}
